import { TooltipIcon } from "@components";
import { ReactNode } from "react";

interface CardTitleProps {
  label: ReactNode;
  hint?: string;
}

const CardTitle = ({ label, hint }: CardTitleProps) => (
  <div className="flex align-center">
    <span className="network-threat-intel_header-label">{label}</span>
    {hint && <TooltipIcon size={14} icon="info-circle" message={hint} />}
  </div>
);

export default CardTitle;
